import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { NIRVANA_COLORS } from "@front-shared/config/theme.config"
import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import { ISelectTabsItem } from "../types/objects.types"

export const SelectTabsComponent = <TValue extends string | number>(
    props: ISelectTabsComponentProps<TValue>,
) => {
    return (
        <div
            className={`
                flex rounded-[100px] p-[4px] gap-[4px] w-fit h-fit
                bg-brand-warmLight2 border border-solid border-brand-offWhite2
                ${props.className ?? ""}
            `}
            role="tablist"
            aria-label={props.ariaLabel}
        >
            {props.items.map(item => {
                const isSelected = item.value === props.value

                return (
                    <ButtonElement
                        key={item.value}
                        htmlType="button"
                        type="default"
                        role="tab"
                        ariaSelected={isSelected}
                        size="middle"
                        onClick={() => {
                            props.onChange(item.value)
                        }}
                        buttonClassName={`
                            !flex !items-center !justify-center !gap-[8px]
                            !rounded-[100px] !px-[20px] !py-[10px] !min-w-[120px] !h-auto !shadow-none !border-0
                            transition-colors
                            ${
                                isSelected
                                    ? "!bg-brand-primary hover:!bg-brand-primary"
                                    : "!bg-transparent hover:!bg-brand-warmLight025"
                            }
                        `}
                        disabled={props.disabled || item.disabled}
                    >
                        {item.icon && (
                            <FontAwesomeIcon
                                icon={item.icon}
                                className="text-[16px] shrink-0"
                                style={{
                                    color: isSelected
                                        ? NIRVANA_COLORS.brand.white
                                        : NIRVANA_COLORS.brand.primary,
                                }}
                            />
                        )}

                        <PrimaryText
                            typography="buttonText"
                            color={
                                isSelected
                                    ? NIRVANA_COLORS.brand.white
                                    : NIRVANA_COLORS.brand.primary
                            }
                        >
                            {item.label}
                        </PrimaryText>
                    </ButtonElement>
                )
            })}
        </div>
    )
}

interface ISelectTabsComponentProps<TValue extends string | number> {
    className?: string
    ariaLabel: string
    items: ISelectTabsItem<TValue>[]
    value: TValue
    onChange: (value: TValue) => void
    disabled?: boolean
}
